import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-miterlimit": "10",
  "stroke-width": "4",
  d: "M21 4a16 16 0 1 0 0 32 16 16 0 1 0 0-32Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000",
  "stroke-miterlimit": "10",
  "stroke-width": "4",
  d: "M32.229 32.229 45.5 45.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000",
  "stroke-width": "4",
  d: "M21 10v20M11 20h20"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }